export default "__VITE_ASSET__0244c78b__"